import number from "@frontend/components/vue-good-table/components/types/number";

const HORIZONTAL = 'horizontal';
const VERTICAL = 'vertical';
const LEFT_TO_RIGHT_POSITION = 'left-to-right-position';
const RIGHT_TO_LEFT_WIDTH = 'right-to-left-width';
const TOP_TO_BOTTOM_POSITION = 'top-to-bottom-position';
const BOTTOM_TO_TOP_HEIGHT = 'bottom-to-top-height';

export const RELATED_DIRECTIONS = {
  HORIZONTAL: {value: HORIZONTAL, label: 'Horizontal', selectedBy: []},
  VERTICAL: {value: VERTICAL, label: 'Vertical', selectedBy: []},
  LEFT_TO_RIGHT_POSITION: {value: LEFT_TO_RIGHT_POSITION, label: 'Left to Right (position)', selectedBy: [LEFT_TO_RIGHT_POSITION, HORIZONTAL]},
  RIGHT_TO_LEFT_WIDTH: {value: RIGHT_TO_LEFT_WIDTH, label: 'Right to Left (width)', selectedBy: [RIGHT_TO_LEFT_WIDTH]},
  TOP_TO_BOTTOM_POSITION: {value: TOP_TO_BOTTOM_POSITION, label: 'Top to Bottom (position)', selectedBy: [TOP_TO_BOTTOM_POSITION, VERTICAL]},
  BOTTOM_TO_TOP_HEIGHT: {value: BOTTOM_TO_TOP_HEIGHT, label: 'Bottom to Top (height)', selectedBy: [BOTTOM_TO_TOP_HEIGHT]},
};

function getReducedAngle(angle) {
  return angle % 360;
}

function getTriangleAngle(angle) {
  if ((angle > 0 && angle < 90) || (angle > 180 && angle < 270)) {
    return angle % 90;
  } else {
    return angle % (-90)
  }
}

function findOppositeCathetus(adjacent, angleDegrees) {
  const angleRadians = angleDegrees * (Math.PI / 180);
  return adjacent * Math.tan(angleRadians);
}

function findAdjacentCathetus(opposite, angleDegrees) {
  const angleRadians = angleDegrees * (Math.PI / 180);
  return opposite / Math.tan(angleRadians);
}

export function getRelatedElementCoords(
  coords,
  element,
  modifyOptions,
  relatedElement,
  left = 0.0,
  top = 0.0
) {
  if (!relatedElement) {
    return coords;
  }

  let relatedLeft = parseFloat(relatedElement.left);
  let relatedTop = parseFloat(relatedElement.top);
  let relatedWidth = parseFloat(relatedElement.width);
  let relatedHeight = parseFloat(relatedElement.height);
  let angle = parseFloat(relatedElement.angle)
  let margin = parseFloat(modifyOptions.margin);
  let elementTop = coords.top || parseFloat(element.top);
  let elementLeft = coords.left || parseFloat(element.left);
  let elementWidth = coords.width || parseFloat(element.width);

  if ([HORIZONTAL, LEFT_TO_RIGHT_POSITION].includes(modifyOptions.direction)) {
    if (relatedElement.type === 'line' && angle > 0) {
      let triangleHeight = Math.abs(elementTop - relatedTop);
      let reducedAngle = getReducedAngle(angle);
      let triangleAngle = getTriangleAngle(reducedAngle);

      if ((reducedAngle % 180) === 0 || triangleAngle === 0) {
        coords.left = 0;
      } else if (triangleAngle > 0 ) {
        coords.left = findAdjacentCathetus(triangleHeight, triangleAngle);
      } else {
        coords.left = findOppositeCathetus(triangleHeight, -1 * triangleAngle);
      }
    } else {
      coords.left = relatedWidth;
    }
    coords.left += left + relatedLeft + margin;
  } else if ([VERTICAL, TOP_TO_BOTTOM_POSITION].includes(modifyOptions.direction)) {
    coords.top = top + relatedTop + relatedHeight + margin;
  } else if ([RIGHT_TO_LEFT_WIDTH].includes(modifyOptions.direction)) {
    coords.width = relatedLeft - elementLeft - margin;
  }

  return coords;
}

export function processMultiRelatedFields(multiRelatedFields) {
  let keys = Object.keys(multiRelatedFields);
  return [
    RELATED_DIRECTIONS.VERTICAL.value,
    RELATED_DIRECTIONS.TOP_TO_BOTTOM_POSITION.value,
    RELATED_DIRECTIONS.HORIZONTAL.value,
    RELATED_DIRECTIONS.LEFT_TO_RIGHT_POSITION.value,
    RELATED_DIRECTIONS.RIGHT_TO_LEFT_WIDTH.value,
  ].reduce((acc, direction) => {
    keys.forEach(key => {
      let options = multiRelatedFields[key];
      if (options.direction === direction) {
        acc.push({
          field: key,
          ...options,
        });
      }
    });

    return acc;
  }, []);
}
